import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { NAV, SOLUTIONS, PHONE, PHONE_TEL, EMAIL } from "@/data/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden bg-[#0E2657] pt-24 text-slate-300">
    <div className="container-x relative z-10 grid gap-14 pb-16 md:grid-cols-12">
      <div className="md:col-span-5">
        <Logo className="h-16 w-auto" />
        <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-400">
          Managed IT, dispatch and onsite support nationwide across the USA — at a very reasonable cost.
        </p>
        <div className="mt-8 space-y-3 text-sm">
          <a href={`tel:${PHONE_TEL}`} className="flex items-center gap-3 transition-colors hover:text-cyan-300" data-testid="footer-phone"><Phone className="h-4 w-4 text-cyan-400" /> {PHONE}</a>
          <a href={`mailto:${EMAIL}`} className="flex items-center gap-3 transition-colors hover:text-cyan-300" data-testid="footer-email"><Mail className="h-4 w-4 text-cyan-400" /> {EMAIL}</a>
          <p className="flex items-center gap-3"><MapPin className="h-4 w-4 text-cyan-400" /> [Office address]</p>
        </div>
      </div>
      <div className="md:col-span-3">
        <p className="eyebrow text-cyan-400">Solutions</p>
        <ul className="mt-5 space-y-3 text-sm">
          {SOLUTIONS.map((s) => (
            <li key={s.id}>
              <Link to={`/solutions#${s.id}`} className="transition-colors hover:text-white" data-testid={`footer-solution-${s.id}`}>{s.title}</Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="md:col-span-2">
        <p className="eyebrow text-cyan-400">Company</p>
        <ul className="mt-5 space-y-3 text-sm">
          {NAV.map((n) => (
            <li key={n.to}>
              <Link to={n.to} className="transition-colors hover:text-white" data-testid={`footer-nav-${n.to.slice(1)}`}>{n.label}</Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="md:col-span-2">
        <p className="eyebrow text-cyan-400">Support</p>
        <p className="mt-5 text-sm text-slate-400">24/7/365 helpdesk and live dispatch desk.</p>
        <span className="mt-4 inline-flex items-center gap-2 rounded-full border border-emerald-400/30 px-3 py-1 text-xs text-emerald-300">
          <span className="pulse-dot h-2 w-2 rounded-full bg-emerald-400 text-emerald-400" /> All systems operational
        </span>
      </div>
    </div>
    <div aria-hidden="true" className="pointer-events-none select-none px-3 font-display text-[17vw] font-extrabold leading-[0.8] tracking-tighter text-white/[0.04]">
      Bodhatek
    </div>
    <div className="container-x relative z-10 flex flex-col gap-2 border-t border-white/10 py-6 text-xs text-slate-400 sm:flex-row sm:justify-between">
      <p>© 2026 Bodhatek. All rights reserved.</p>
      <p className="font-mono uppercase tracking-[0.2em]">Managed. Dispatched. Delivered.</p>
    </div>
  </footer>
);
